<script setup lang="ts" name="RegistrationSearchSelectMultiple">
import {
  BASE_TAG_CONTRAST,
  REGISTRATION_SEARCH_OPTION_TYPE,
} from '~/constants';

import BaseTag from '~/components/BaseTag.vue';
import RegistrationCheckboxInput from '~/components/RegistrationCheckboxInput.vue';

import type { IRegistrationHighlightedOption } from '~/types';

defineProps<{
  title: string;
  options: IRegistrationHighlightedOption[];
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', options: IRegistrationHighlightedOption): void;
}>();

const getTagVariantText = (portCount: number) =>
  `${portCount} ${portCount === 1 ? 'Trade' : 'Trades'}`;
</script>

<template>
  <div>
    <p
      class="min-w-full bg-charcoal-2 px-4 py-2 text-button-1 uppercase text-charcoal-6"
    >
      {{ title }}
    </p>

    <div data-test="registration-search-options">
      <RegistrationCheckboxInput
        v-for="option in options"
        :key="option.id"
        :option="option"
        @update:model-value="emit('update:modelValue', $event)"
      >
        <div class="flex justify-between">
          <p
            class="text-body-1 text-secondary-9 group-hover:text-primary-8"
            v-html="option.highlightedName"
          ></p>

          <BaseTag
            v-if="option.type !== REGISTRATION_SEARCH_OPTION_TYPE.TRADES"
            :name="getTagVariantText(option.inTradelanes.length)"
            :variant="BASE_TAG_CONTRAST.CHARCOAL_1"
          />
        </div>
      </RegistrationCheckboxInput>
    </div>
  </div>
</template>
